<template>
    <div class="flex flex-wrap items-center justify-center">
        <div class="absolute top-4 sm:top-8 right-8">
            <a class="font-bold text-teal" href="#" @click="changeLocale('en')">ENG</a>
            <span class="inline-block font-bold text-teal mx-2">|</span>
            <a class="font-bold text-teal" href="#" @click="changeLocale('it')">ITA</a>
        </div>
        <div class="w-full lg:w-5/12 px-6 text-center py-6 lg:h-screen bg-white flex flex-wrap items-center">
            <form class="w-full px-6 xl:px-20 2xl:px-32 text-left mt-4">
                <router-link to="/"><img src="@/assets/images/logo.png" class="h-10 w-auto h-auto max-h-10 mx-auto"></router-link>

                <h1 class="uppercase text-xl sm:text-2xl mt-6 font-extrabold max-w-sm text-center mx-auto">{{ $t("concorso di idee") }}</h1>
                <h2 class="text-sm sm:text-base font-semibold text-center">'Il Chilometro verde'</h2>
                
                <label class="block text-green-dark mt-12">{{ $t("Email") }}</label>
                <input v-model="email" type="email" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1">
                <div v-if="error" class="block text-red-500 text-xs ml-4">{{ error }}</div>

                <button @click.prevent="passwordEmail" class="relative font-medium bg-green-light text-white px-12 py-2 rounded-full mt-10 block w-full focus:outline-none" :disabled="loading">{{ $t("Request new password") }}
                    <loaderIco class="h-5 w-5 text-white" v-if="loading" />
                </button>
                <div v-if="success" class="w-full bg-green-light shadow-sm rounded-lg text-green-dark font-bold p-4 mt-4">{{ $t("We sent you an email with the instructions to reset your password") }}</div>                
            </form>
            <div class="mt-16 lg:mt-24 text-center px-6 pb-4 w-full">
                {{ $t("Don't have an account yet?") }}
                <router-link to="/register" class="text-orange underline font-bold">{{ $t("Register here") }}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import loaderIco from '@/svg/loader.vue'
import firebase from 'firebase/app'
import "@firebase/auth";

export default {
    components: { loaderIco },
    data() {
        return {
        	success: false,
            email: '',
            error: null,
            loading: false
        }
    },
    computed: {

    },
    methods: {
        passwordEmail() {
            this.loading = true
            firebase
                .auth()
                .sendPasswordResetEmail(this.email)                
                .then(response => {
                	this.error = false
                    this.loading = false
                    this.success = true
                })
                .catch(error => {
                    this.loading = false
                    switch(error.code) {
                        case 'auth/invalid-email': 
                            this.error = this.$t('Indirizzo email non valido')
                        break;
                        case 'auth/user-not-found': 
                            this.error = this.$t('Indirizzo email non registrato')
                        break;
                        default:
                            this.error = this.$t('Impossibile effettuare la registrazione, riprova tra qualche minuto')
                    }
                })
        }
    },
}
</script>